import { render } from "./SearchArea.vue?vue&type=template&id=f38dd1b4&ts=true"
import script from "./SearchArea.vue?vue&type=script&lang=ts"
export * from "./SearchArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__